// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5-Sje","question":"styles_question__30Zs3","description":"styles_description__1_Kc8"};